import * as AsyncData from "foldkit/asyncData";

import type { Model as SearchedModel } from "../pages/searched/model";
import { isEmptyCircle } from "../pages/searched/update";

/**
 * First-run import offer (R20, KTD7). No per-user server storage exists without
 * a migration, so "already offered" is a `localStorage` flag: sticky per
 * browser, not per account. A second browser sees the offer again.
 */
const STORAGE_KEY = "import-onboarding-dismissed";

/** Read synchronously in `init`, as `developerOptions` reads its own flag: the
 * decision never has a loading state. Private mode throws; that reads as "not
 * dismissed", so the offer simply reappears next session. */
export const readImportDismissed = (): boolean => {
	try {
		return localStorage.getItem(STORAGE_KEY) === "1";
	} catch {
		return false;
	}
};

export const writeImportDismissed = (): void => {
	try {
		localStorage.setItem(STORAGE_KEY, "1");
	} catch {
		// Private mode: nothing persists, and nothing here should throw.
	}
};

/**
 * The first-run decision (KTD7): the circle resolved to nothing at all and the
 * offer has not been dismissed. On Records that is an empty records list; on
 * Home, where the list is never fetched, it is an empty week beside an empty
 * recent list. Idle, loading and failed all decline — an empty screen the
 * fetch never filled is not an empty circle.
 */
export const shouldOfferImport = (
	model: SearchedModel,
	dismissed: boolean,
): boolean =>
	!dismissed &&
	((AsyncData.isSuccess(model.results) &&
		model.results.data.items.length === 0) ||
		(AsyncData.isSuccess(model.recent) && isEmptyCircle(model)));
